import { gql } from '@apollo/client';
import type { UpcomingTickets } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

class GraphQLUpcomingTicketsRequester {
  public getUpcomingTickets = (): Promise<UpcomingTickets | null> => {
    return graphQLRequester
      .query<{ upcomingTickets: UpcomingTickets | null }>({
        query: gql`
          query upcomingTickets {
            upcomingTickets {
              daysWithoutMovement
              hasUpsell
              nextBatchScheduledAt
              tickets {
                id
                type
                status
                createdAt
              associatedDealId
                deviceTotalQuantity {
                  total
                  installed
                }
                ... on Scheduling {
                  scheduledDate
                  installedDate
                }
                ... on Shipping {
                  shippingDate
                  estimatedTimeOfArrival
                }
                ... on Return {
                  deadline
                  postingDate
                  scheduleDate
                }
              }
            }
          }
        `,
      })
      .then((response) => response.upcomingTickets ?? null);
  };
}

export default GraphQLUpcomingTicketsRequester;
